import NotificacaoGeralService from '../../services/NotificacaoGeralService'

const state = () => ({
    notificacoesGerais: [],
    loadingNotificacoesGerais: false
})
  
const mutations = {
    SET_NOTIFICACOES_GERAIS: (state, payload) => {
        state.notificacoesGerais = payload
    },
    SET_LOADING_NOTIFICACOES_GERAIS: (state, payload) => {
        state.loadingNotificacoesGerais = payload
    }
}

const actions = {
    async fetchNotificacoesGeraisAtivas({commit}){
        try{
            commit('SET_LOADING_NOTIFICACOES_GERAIS', true)
            const response = await NotificacaoGeralService.getAtivas();
            commit('SET_NOTIFICACOES_GERAIS', response.data.itens || [])
            commit('SET_LOADING_NOTIFICACOES_GERAIS', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICACOES_GERAIS', false)
            console.error('Erro ao carregar notificações gerais:', error)
        }
    }
}

const getters = {
    getNotificacoesGerais: state => state.notificacoesGerais,
    getLoadingNotificacoesGerais: state => state.loadingNotificacoesGerais
}

export default {
    state,
    getters,
    mutations,
    actions
};